module.exports = __webpack_public_path__ + "images/fdd5016ee95f01016317c811e70a0260.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/julia_mobile.jpg
// module id = 130
// module chunks = 24